module.exports = __webpack_public_path__ + "img/treasure.75b6a2bb.png";